import {
  ref, watch, computed,
} from '@vue/composition-api';
import store from '@/store';
import { showToast } from '@core/utils/utils';
import useFiles from '../files/useFiles';
// import { deepMerge } from '@/libs/commons';
// import tinymceIcons from '@/libs/tinymceIcons';

export default function useSettings() {
  const refListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: false, thAttr: { width: '30' } },
    {
      key: 'skey',
      sortable: false,
      label: 'Key',
      thAttr: { width: '200' },
    },
    {
      key: 'group',
      sortable: false,
      label: 'Nhóm',
      thAttr: { width: '200' },
    },
    {
      key: 'name',
      sortable: false,
      label: 'Tên',
    },
    {
      key: 'actions',
      label: 'Hành động',
      thAttr: { width: '200' },
      thClass: 'text-right',
      tdClass: 'text-right',
    },
  ];
  const loading = ref(false);
  const uploadLoading = ref(false);
  const perPage = ref(10);
  const totalEntries = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const settingFilter = ref(null);
  const statusFilter = ref(null);
  const isPaginate = ref(0);
  const defaultSetting = {
    app: {
      logo_mask: '',
      fb_chat: '',
      fb_chat_enable: false,
      zalo_chat: '',
      zalo_chat_enable: false,
      google_client_id: '',
      google_client_secret: '',
    },
    auth: {
      user_guide_file: '',
      organization: '',
      phones: '',
      logout_time: 3 * 60, // minutes
      number_login_fail: 5,
      login_background: '',
      forgotpass_polls: [],
    },
    mailer: {
      mail_driver: '',
      mail_host: '',
      mail_port: '',
      mail_username: '',
      mail_password: '',
      mail_encryption: '',
      mail_from_name: '',
      mailsupport: '',
    },
    files: {
      audio_mimetypes: '',
      video_mimetypes: '',
      image_mimetypes: '',
      document_mimetypes: '',
      user_limit_storage: 0,
      max_duration_to_dalet: 0,
      max_size_to_dalet: 0,
      number_day_remove_file: 0,
    },
    home: {
      weblinks: '<ul><li><a href="/">http://tintinvov.vn</a></li><li><a href="/">http://tintinvov.vn</a></li><li><a href="/">https://trungtamtin.tnvn.vn</a></li></ul>',
      organization: '<ul><li>Trung tâm Sản xuất và lưu trữ chương trình</li><li>Địa chỉ: 39 Bà Triệu - Hoàn Kiếm - Hà Nội</li><li>Điện thoại: (+84 24) 38253498</li></ul>',
      contact: '<ul><li>Tel: (+84 24) 38253498</li><li><a href="mailto:tinbaivov@gmail.com">tinbaivov@gmail.com</a></li></ul>',
    },
  };

  const defaultAudioMimetypes = useFiles().audioMimetypes;
  const defaultVideoMimetypes = useFiles().videoMimetypes;
  const defaultImageMimetypes = useFiles().imageMimetypes;
  const defaultDocumentMimetypes = useFiles().documentMimetypes;

  const extractMimetype = (type) => {
    const arr = [];
    switch (type) {
      case 'audio':
        defaultAudioMimetypes.forEach(o => {
          arr.push(o.mimetype);
        });
        break;
      case 'video':
        defaultVideoMimetypes.forEach(o => {
          arr.push(o.mimetype);
        });
        break;
      case 'image':
        defaultImageMimetypes.forEach(o => {
          arr.push(o.mimetype);
        });
        break;
      case 'document':
        defaultDocumentMimetypes.forEach(o => {
          arr.push(o.mimetype);
        });
        break;
      default:
        break;
    }
    // console.log('defaultAudioMimetypes', defaultAudioMimetypes, arr);
    return arr.length ? arr.join('\n') : '';
  }
  const settingDatas = computed(() => {
    if (store.state.app.settings) {
      if (store.state.app.settings.files === undefined) {
        store.state.app.settings.files = {
          audio_mimetypes: extractMimetype('audio'),
          video_mimetypes: extractMimetype('video'),
          image_mimetypes: extractMimetype('image'),
          document_mimetypes: extractMimetype('document'),
        }
      }
      if (store.state.app.settings.home === undefined) {
        store.state.app.settings.home = defaultSetting.home
      }
      // console.log('store.state.app.settings', store.state.app.settings);
      return store.state.app.settings;
    }
    return defaultSetting;
  });

  const defaultSettingNews = {
    editor_toolbar: [
      'undo', 'redo', 'fontselect', 'fontsizeselect', 'bold', 'italic', 'underline', 'strikethrough', 'alignleft', 'aligncenter', 'alignright', 'alignjustify', 'numlist', 'bullist', 'table', 'image', 'media', 'link', 'removeformat', 'fullscreen', 'code', 'lineheight'
    ],
    time_remove_news: 7,
    time_remove_mapping_news: 7,
  };

  const uploadImage = (data, cb) => {
    const { file, returnData } = data;
    uploadLoading.value = true;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', returnData.name);
    formData.append('group', returnData.group);
    formData.append('skey', returnData.skey);
    formData.append('svalue', settingDatas.value.auth[returnData.skey]);
    store.dispatch('settings/upload', formData)
      .then((res) => {
        uploadLoading.value = false;
        if (res.status === 200) {
          settingDatas.value.auth[returnData.skey] = res.data.data.file;
          if (typeof cb === 'function') {
            cb(res.data.data);
          }
        } else {
          // console.log(res.data.message)
        }
      })
  };
  const removeImage = (data, cb) => {
    const { file, returnData } = data;
    uploadLoading.value = true;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', returnData.name);
    formData.append('group', returnData.group);
    formData.append('skey', returnData.skey);
    formData.append('svalue', settingDatas.value.auth[returnData.skey]);
    store.dispatch('settings/removeFile', formData)
      .then((res) => {
        if (res.status === 200) {
          uploadLoading.value = false;
          settingDatas.value.auth.login_background = res.data.data.file;
          if (typeof cb === 'function') {
            cb('');
          }
        } else {
          // console.log(res.data.message)
        }
      })
  };

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEntries.value,
    };
  });

  const fetchSettings = () => {
    loading.value = true;
    store
      .dispatch('settings/fetchSettings', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        isPaginate: isPaginate.value,
      })
      .then((response) => {
        loading.value = false;
        if (response.status === 200) {
          // eslint-disable-next-line no-prototype-builtins
          if (!response.data.data.hasOwnProperty('news')) {
            // eslint-disable-next-line no-param-reassign
            response.data.data.news = defaultSettingNews;
          }
          settingDatas.value = Object.assign(settingDatas.value, response.data.data)
        }
      });
  };
  const saveSettings = (data) => {
    loading.value = true
    store
      .dispatch('settings/updateAllSetting', data)
      .then((response) => {
        loading.value = false;
        if (response.status === 200) {
          showToast(response.data.message, { variant: 'success' });
        } else {
          showToast(response.data.message);
        }
      });
  };

  // const refetchData = () => {
  //   fetchSettings();
  // };

  // watch([currentPage, perPage, searchQuery, statusFilter], () => {
  //   refetchData();
  // });

  // watch(() => store.state.app.settings, () => {
  //   console.log('app seting changed: ', store.state.app.settings);
  // });

  const statusOptions = [
    { label: 'Đợi duyệt', id: 2 },
    { label: 'Đã kích hoạt', id: 1 },
    { label: 'Chưa kích hoạt', id: 0 },
  ];
  const resolveUserStatusVariant = (status) => {
    if (status === 2) return 'warning';
    if (status === 1) return 'success';
    if (status === 0) return 'secondary';
    return 'primary';
  };
  const resolveUserStatusText = (status) => statusOptions.find((x) => x.id === status).label;

  return {
    loading,
    tableColumns,
    perPage,
    currentPage,
    totalEntries,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    settingDatas,

    fetchSettings,
    saveSettings,
    resolveUserStatusVariant,
    resolveUserStatusText,
    // refetchData,

    // Extra Filters
    settingFilter,
    statusFilter,
    statusOptions,
    uploadLoading,
    uploadImage,
    removeImage,
  };
}
